import RouteKey from '@/common/RouteKey';
import Layout from '@/components/open/common/Constant';

import OpenApp from '@/components/open/OpenApp';
import Home from '@/components/open/panels/home/Home';

import ApplicationContainer from '@/components/open/panels/application/ApplicationContainer';
import NewMessage from '@/components/open/panels/application/panels/NewMessage';
import PublicCloudDisplay from '@/components/open/panels/application/panels/PublicCloudDisplay';
import PublicCloudCreator from '@/components/open/panels/application/panels/PublicCloudCreator';
import PrivateCloudDisplay from '@/components/open/panels/application/panels/PrivateCloudDisplay';
import PrivateCloudCreator from '@/components/open/panels/application/panels/PrivateCloudCreator';
import YoutuBoxDisplay from '@/components/open/panels/application/panels/YoutuBoxDisplay';
import YoutuBoxCreator from '@/components/open/panels/application/panels/YoutuBoxCreator';
import OfflineSdkDisplay from '@/components/open/panels/application/panels/OfflineSdkDisplay';
import OfflineSdkCreator from '@/components/open/panels/application/panels/OfflineSdkCreator';

import AboutUSContainer from '@/components/open/panels/aboutus/AboutusContainer';
import AboutUS from '@/components/open/panels/aboutus/Aboutus';
import Partner from '@/components/open/panels/aboutus/panels/Partner';
import Contactus from '@/components/open/panels/aboutus/panels/Contactus';

import Validate from '@/components/open/panels/validate/Validate';
import PhoneValidate from '@/components/open/panels/validate/panels/PhoneValidate';
import MailValidate from '@/components/open/panels/validate/panels/MailValidate';
import ResultValidate from '@/components/open/panels/validate/panels/ResultValidate';
import MailActive from '@/components/open/panels/validate/panels/MailActive';

import SolutionContainer from '@/components/open/panels/solution/SolutionContainer';
import SolutionFaceIn from '@/components/open/panels/solution/panels/SolutionFaceIn';
import SolutionAuditing from '@/components/open/panels/solution/panels/SolutionAuditing';
import SolutionBroadcast from '@/components/open/panels/solution/panels/SolutionBroadcast';
import SolutionFaceInFW from '@/components/open/panels/solution/panels/SolutionFaceInFW';
import SolutionAdult from '@/components/open/panels/solution/panels/SolutionAdult';
import SolutionTim from '@/components/open/panels/solution/panels/SolutionTim';
import SolutionForgery from '@/components/open/panels/solution/panels/SolutionForgery';
import SolutionInvoice from '@/components/open/panels/solution/panels/SolutionInvoice';
import SolutionEducation from '@/components/open/panels/solution/panels/SolutionEducation';
import SolutionInsurance from '@/components/open/panels/solution/panels/SolutionInsurance';
import SolutionSDKProction from '@/components/open/panels/solution/panels/SolutionSDKProduction';

import Cooperation from '@/components/open/panels/cooperation/Cooperation';

import NewsCenter from '@/components/open/panels/news/NewsCenter';
import NewsCenterHome from '@/components/open/panels/news/NewsCenterHome';
import News1 from '@/components/open/panels/news/detail/News1';
import News2 from '@/components/open/panels/news/detail/News2';
import News3 from '@/components/open/panels/news/detail/News3';
import News4 from '@/components/open/panels/news/detail/News4';
import News5 from '@/components/open/panels/news/detail/News5';
import News6 from '@/components/open/panels/news/detail/News6';
import News7 from '@/components/open/panels/news/detail/News7';
import News8 from '@/components/open/panels/news/detail/News8';
import News9 from '@/components/open/panels/news/detail/News9';
import News10 from '@/components/open/panels/news/detail/News10';
import News11 from '@/components/open/panels/news/detail/News11';
import News12 from '@/components/open/panels/news/detail/News12';
import News13 from '@/components/open/panels/news/detail/News13';
import News14 from '@/components/open/panels/news/detail/News14';
import News15 from '@/components/open/panels/news/detail/News15';
import News16 from '@/components/open/panels/news/detail/News16';
import News17 from '@/components/open/panels/news/detail/News17';
import News18 from '@/components/open/panels/news/detail/News18';
import News19 from '@/components/open/panels/news/detail/News19';
import News20 from '@/components/open/panels/news/detail/News20';
import News21 from '@/components/open/panels/news/detail/News21';
import News22 from '@/components/open/panels/news/detail/News22';
import News23 from '@/components/open/panels/news/detail/News23';
import News24 from '@/components/open/panels/news/detail/News24';
import News25 from '@/components/open/panels/news/detail/News25';
import News26 from '@/components/open/panels/news/detail/News26';
import News27 from '@/components/open/panels/news/detail/News27';
import News28 from '@/components/open/panels/news/detail/News28';
import News29 from '@/components/open/panels/news/detail/News29';
import News30 from '@/components/open/panels/news/detail/News30';
import News31 from '@/components/open/panels/news/detail/News31';
import News32 from '@/components/open/panels/news/detail/News32';
import News33 from '@/components/open/panels/news/detail/News33';
import News34 from '@/components/open/panels/news/detail/News34';
import News35 from '@/components/open/panels/news/detail/News35';
import News36 from '@/components/open/panels/news/detail/News36';
import News37 from '@/components/open/panels/news/detail/News37';
import News38 from '@/components/open/panels/news/detail/News38';
import News39 from '@/components/open/panels/news/detail/News39';
import News40 from '@/components/open/panels/news/detail/News40';
import News41 from '@/components/open/panels/news/detail/News41';
import News42 from '@/components/open/panels/news/detail/News42';
import News43 from '@/components/open/panels/news/detail/News43';
import News44 from '@/components/open/panels/news/detail/News44';
import News45 from '@/components/open/panels/news/detail/News45';
import News46 from '@/components/open/panels/news/detail/News46';
import News47 from '@/components/open/panels/news/detail/News47';
import News48 from '@/components/open/panels/news/detail/News48';
import News49 from '@/components/open/panels/news/detail/News49';
import News50 from '@/components/open/panels/news/detail/News50';
import News51 from '@/components/open/panels/news/detail/News51';
import News52 from '@/components/open/panels/news/detail/News52';
import News53 from '@/components/open/panels/news/detail/News53';
import News54 from '@/components/open/panels/news/detail/News54';
import News55 from '@/components/open/panels/news/detail/News55';
import News56 from '@/components/open/panels/news/detail/News56';
import News57 from '@/components/open/panels/news/detail/News57';
import News58 from '@/components/open/panels/news/detail/News58';
import News59 from '@/components/open/panels/news/detail/News59';
import News60 from '@/components/open/panels/news/detail/News60';
import News61 from '@/components/open/panels/news/detail/News61';
import News62 from '@/components/open/panels/news/detail/News62';
import News63 from '@/components/open/panels/news/detail/News63';
import News64 from '@/components/open/panels/news/detail/News64';
import News65 from '@/components/open/panels/news/detail/News65';
import News66 from '@/components/open/panels/news/detail/News66';
import News67 from '@/components/open/panels/news/detail/News67';
import News68 from '@/components/open/panels/news/detail/News68';
import News69 from '@/components/open/panels/news/detail/News69';
import News70 from '@/components/open/panels/news/detail/News70';
import News71 from '@/components/open/panels/news/detail/News71';
import News72 from '@/components/open/panels/news/detail/News72';
import News73 from '@/components/open/panels/news/detail/News73';
import News74 from '@/components/open/panels/news/detail/News74';
import News75 from '@/components/open/panels/news/detail/News75';
import News76 from '@/components/open/panels/news/detail/News76';
import News77 from '@/components/open/panels/news/detail/News77';
import News78 from '@/components/open/panels/news/detail/News78';
import News79 from '@/components/open/panels/news/detail/News79';
import News80 from '@/components/open/panels/news/detail/News80';
import News81 from '@/components/open/panels/news/detail/News81';
import News82 from '@/components/open/panels/news/detail/News82';
import Academic from '@/components/open/panels/academic/Academic';
import Article from '@/components/article/Article';

export default {
  path: '/open',
  component: OpenApp,
  meta: {
    exportKey: RouteKey.OPEN_APP,
    isHomeActive: true
  },
  children: [{
    path: '/',
    alias: 'home',
    component: Home,
    meta: {
      exportKey: RouteKey.OPEN_HOME,
      needLoginAndVerifyMail: false,
      flexMode: Layout.LayoutMode.FLEX,
      isHomeActive: true
    }
  }, {
    path: '/introduce',
    alias: 'introduce',
    component: Article,
    meta: {
      exportKey: RouteKey.Article,
      isArticleActive: true
    }
  }, {
    path: '/open/application',
    alias: 'application',
    component: ApplicationContainer,
    children: [{
      alias: '/',
      path: 'all',
      component: PublicCloudDisplay,
      meta: {
        exportKey: RouteKey.OPEN_APP_DISPLAY,
        needLoginAndVerifyMail: true,
        flexMode: Layout.LayoutMode.DEFAULT,
        appFooter: true
      }
    }, {
      path: 'create-app',
      component: PublicCloudCreator,
      meta: {
        exportKey: RouteKey.OPEN_APP_CREATOR,
        needLoginAndVerifyMail: true,
        flexMode: Layout.LayoutMode.DEFAULT,
        appFooter: true
      }
    }, {
      path: 'offline-sdk',
      component: OfflineSdkDisplay,
      meta: {
        exportKey: RouteKey.OPEN_SDK_DISPLAY,
        needLoginAndVerifyMail: true,
        flexMode: Layout.LayoutMode.DEFAULT,
        appFooter: true
      }
    }, {
      path: 'create-offline-sdk',
      component: OfflineSdkCreator,
      meta: {
        exportKey: RouteKey.OPEN_SDK_CREATOR,
        needLoginAndVerifyMail: true,
        flexMode: Layout.LayoutMode.DEFAULT,
        appFooter: true
      }
    }, {
      path: 'private-cloud',
      component: PrivateCloudDisplay,
      meta: {
        exportKey: RouteKey.OPEN_PRIVATE_DISPLAY,
        needLoginAndVerifyMail: true,
        flexMode: Layout.LayoutMode.DEFAULT,
        appFooter: true
      }
    }, {
      path: 'create-private-cloud',
      component: PrivateCloudCreator,
      meta: {
        exportKey: RouteKey.OPEN_PRIVATE_CREATOR,
        needLoginAndVerifyMail: true,
        flexMode: Layout.LayoutMode.DEFAULT,
        appFooter: true
      }
    }, {
      path: 'youtu-box',
      component: YoutuBoxDisplay,
      meta: {
        exportKey: RouteKey.OPEN_YOUTU_BOX_DISPLAY,
        needLoginAndVerifyMail: true,
        flexMode: Layout.LayoutMode.DEFAULT,
        appFooter: true
      }
    }, {
      path: 'create-youtu-box',
      component: YoutuBoxCreator,
      meta: {
        exportKey: RouteKey.OPEN_YOUTU_BOX_CREATOR,
        needLoginAndVerifyMail: true,
        flexMode: Layout.LayoutMode.DEFAULT,
        appFooter: true
      }
    }, {
      path: 'message',
      component: NewMessage,
      meta: {
        exportKey: RouteKey.OPEN_APP_MESSAGE,
        needLoginAndVerifyMail: true,
        flexMode: Layout.LayoutMode.DEFAULT,
        appFooter: true
      }
    }]
  }, {
    path: '/open/aboutus',
    alias: 'aboutus',
    component: AboutUSContainer,
    children: [{
      path: '/',
      alias: 'aboutus',
      component: AboutUS,
      meta: {
        exportKey: RouteKey.OPEN_ABOUTUS_INTRO,
        flexMode: Layout.LayoutMode.FLEX,
        appFooter: true,
        isAboutTTActive: true
      }
    }, {
      path: '/open/aboutus/partner',
      component: Partner,
      meta: {
        exportKey: RouteKey.OPEN_ABOUTUS_PARTNER,
        flexMode: Layout.LayoutMode.FLEX,
        appFooter: true,
        isAboutusFormActive: true
      }
    }, {
      path: '/open/aboutus/contactus',
      component: Contactus,
      meta: {
        exportKey: RouteKey.OPEN_ABOUTUS_CONTACTUS,
        flexMode: Layout.LayoutMode.FLEX,
        appFooter: true,
        isAboutusFormActive: true
      }
    }]
  }, {
    path: '/open/validate',
    alias: 'validate',
    component: Validate,
    children: [{
      path: '/',
      alias: 'phone',
      component: PhoneValidate,
      meta: {
        exportKey: RouteKey.OPEN_VERIFY_PHONE,
        flexMode: Layout.LayoutMode.DEFAULT,
        appFooter: true
      }
    }, {
      path: 'mail',
      component: MailValidate,
      meta: {
        exportKey: RouteKey.OPEN_VERIFY_MAIL,
        flexMode: Layout.LayoutMode.DEFAULT,
        appFooter: true
      }
    }, {
      path: 'active',
      component: MailActive,
      meta: {
        exportKey: RouteKey.OPEN_ACTIVE_MAIL,
        flexMode: Layout.LayoutMode.DEFAULT,
        appFooter: true
      }
    }, {
      path: 'success',
      component: ResultValidate,
      meta: {
        exportKey: RouteKey.OPEN_VERIFY_SUCCESS,
        flexMode: Layout.LayoutMode.DEFAULT,
        verifyResult: true,
        appFooter: true
      }
    }, {
      path: 'fail',
      component: ResultValidate,
      meta: {
        exportKey: RouteKey.OPEN_VERIFY_FAIL,
        flexMode: Layout.LayoutMode.DEFAULT,
        verifyResult: false,
        appFooter: true
      }
    }]
  }, {
    path: '/open/solution',
    alias: 'solution',
    component: SolutionContainer,
    children: [{
      path: 'facein',
      component: SolutionFaceIn,
      meta: {
        exportKey: RouteKey.OPEN_SOLUTION_FACEIN,
        flexMode: Layout.LayoutMode.FLEX,
        isSolutionActive: true
      }
    }, {
      path: 'auditing',
      component: SolutionAuditing,
      meta: {
        exportKey: RouteKey.OPEN_SOLUTION_AUDITING,
        flexMode: Layout.LayoutMode.FLEX,
        isSolutionActive: true
      }
    }, {
      path: 'broadcast',
      component: SolutionBroadcast,
      meta: {
        exportKey: RouteKey.OPEN_SOLUTION_BROADCAST,
        flexMode: Layout.LayoutMode.FLEX,
        isSolutionActive: true
      }
    }, {
      path: 'faceinfw',
      component: SolutionFaceInFW,
      meta: {
        exportKey: RouteKey.OPEN_SOLUTION_FACEIN_FW,
        flexMode: Layout.LayoutMode.FLEX,
        isSolutionActive: true
      }
    }, {
      path: 'adult',
      component: SolutionAdult,
      meta: {
        exportKey: RouteKey.OPEN_SOLUTION_ADULT,
        flexMode: Layout.LayoutMode.FLEX,
        isSolutionActive: true
      }
    }, {
      path: 'tim',
      component: SolutionTim,
      meta: {
        exportKey: RouteKey.OPEN_SOLUTION_TIM,
        flexMode: Layout.LayoutMode.FLEX,
        isSolutionActive: true
      }
    }, {
      path: 'forgery',
      component: SolutionForgery,
      meta: {
        exportKey: RouteKey.OPEN_SOLUTION_FORGERY,
        flexMode: Layout.LayoutMode.FLEX,
        isSolutionActive: true
      }
    }, {
      path: 'solution-education',
      component: SolutionEducation,
      meta: {
        exportKey: RouteKey.OPEN_SOLUTION_EDUCATION,
        flexMode: Layout.LayoutMode.FLEX,
        isSolutionActive: true
      }
    }, {
      path: 'solution-sdkproduction',
      component: SolutionSDKProction,
      meta: {
        exportKey: RouteKey.OPEN_SOLUTION_SDKPRODUCTION,
        flexMode: Layout.LayoutMode.FLEX,
        isSolutionActive: true
      }
    }, {
      path: 'solution-insurance',
      component: SolutionInsurance,
      meta: {
        exportKey: RouteKey.OPEN_SOLUTION_INSURANCE,
        flexMode: Layout.LayoutMode.FLEX,
        isSolutionActive: true
      }
    }, {
      path: 'invoice-series',
      component: SolutionInvoice,
      meta: {
        exportKey: RouteKey.OPEN_SOLUTION_INVOICE,
        flexMode: Layout.LayoutMode.FLEX,
        isSolutionActive: true
      }
    }]
  }, {
    path: '/open/cooperation',
    alias: 'cooperation',
    component: Cooperation,
    children: [{
      path: '/',
      alias: 'case',
      component: Cooperation,
      meta: {
        exportKey: RouteKey.OPEN_COOPERATION,
        flexMode: Layout.LayoutMode.FLEX,
        isCooperationActive: true
      }
    }]
  }, {
    path: '/open/news',
    alias: 'newscenter',
    component: NewsCenter,
    children: [{
      path: '/',
      alias: 'home',
      component: NewsCenterHome,
      meta: {
        exportKey: RouteKey.OPEN_NEWSCENTER,
        flexMode: Layout.LayoutMode.FLEX,
        isNewsActive: true
      }
    }, {
      path: '/open/news/1',
      alias: 'news1',
      component: News1,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_1,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/2',
      alias: 'news2',
      component: News2,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_2,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/3',
      alias: 'news3',
      component: News3,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_3,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/4',
      alias: 'news4',
      component: News4,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_4,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/5',
      alias: 'news5',
      component: News5,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_5,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/6',
      alias: 'news6',
      component: News6,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_6,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/7',
      alias: 'news7',
      component: News7,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_7,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/8',
      alias: 'news8',
      component: News8,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_8,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/9',
      alias: 'news9',
      component: News9,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_9,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/10',
      alias: 'news10',
      component: News10,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_10,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/11',
      alias: 'news11',
      component: News11,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_11,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/12',
      alias: 'news12',
      component: News12,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_12,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/13',
      alias: 'news13',
      component: News13,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_13,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/14',
      alias: 'news14',
      component: News14,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_14,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/15',
      alias: 'news15',
      component: News15,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_15,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/16',
      alias: 'news16',
      component: News16,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_16,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/17',
      alias: 'news17',
      component: News17,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_17,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/18',
      alias: 'news18',
      component: News18,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_18,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/19',
      alias: 'news19',
      component: News19,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_19,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/20',
      alias: 'news20',
      component: News20,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_20,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/21',
      alias: 'news21',
      component: News21,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_21,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/22',
      alias: 'news22',
      component: News22,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_22,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/23',
      alias: 'news23',
      component: News23,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_23,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/24',
      alias: 'news24',
      component: News24,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_24,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/25',
      alias: 'news25',
      component: News25,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_25,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/26',
      alias: 'news26',
      component: News26,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_26,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/27',
      alias: 'news27',
      component: News27,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_27,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/28',
      alias: 'news28',
      component: News28,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_28,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/29',
      alias: 'news29',
      component: News29,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_29,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/30',
      alias: 'news30',
      component: News30,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_30,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/31',
      alias: 'news31',
      component: News31,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_31,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/32',
      alias: 'news32',
      component: News32,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_32,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/33',
      alias: 'news33',
      component: News33,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_33,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/34',
      alias: 'news34',
      component: News34,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_34,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/35',
      alias: 'news35',
      component: News35,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_35,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/36',
      alias: 'news36',
      component: News36,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_36,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/37',
      alias: 'news37',
      component: News37,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_37,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/38',
      alias: 'news38',
      component: News38,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_38,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/39',
      alias: 'news39',
      component: News39,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_39,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/40',
      alias: 'news40',
      component: News40,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_40,
        flexMode: Layout.LayoutMode.FLEX
      }
    }, {
      path: '/open/news/41',
      alias: 'news41',
      component: News41,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_41,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/42',
      alias: 'news42',
      component: News42,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_42,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/43',
      alias: 'news43',
      component: News43,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_43,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/44',
      alias: 'news44',
      component: News44,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_44,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/45',
      alias: 'news45',
      component: News45,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_45,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/46',
      alias: 'news46',
      component: News46,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_46,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/47',
      alias: 'news47',
      component: News47,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_47,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/48',
      alias: 'news48',
      component: News48,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_48,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/49',
      alias: 'news49',
      component: News49,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_49,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/50',
      alias: 'news50',
      component: News50,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_50,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/51',
      alias: 'news51',
      component: News51,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_51,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/52',
      alias: 'news52',
      component: News52,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_52,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/53',
      alias: 'news53',
      component: News53,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_53,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/54',
      alias: 'news54',
      component: News54,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_54,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/55',
      alias: 'news55',
      component: News55,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_55,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/56',
      alias: 'news56',
      component: News56,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_56,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/57',
      alias: 'news57',
      component: News57,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_57,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/58',
      alias: 'news58',
      component: News58,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_58,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/59',
      alias: 'news59',
      component: News59,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_59,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/60',
      alias: 'news60',
      component: News60,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_60,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/61',
      alias: 'news61',
      component: News61,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_61,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/62',
      alias: 'news62',
      component: News62,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_62,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/63',
      alias: 'news63',
      component: News63,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_63,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/64',
      alias: 'news64',
      component: News64,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_64,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/65',
      alias: 'news65',
      component: News65,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_65,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/66',
      alias: 'news66',
      component: News66,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_66,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/67',
      alias: 'news67',
      component: News67,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_67,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/68',
      alias: 'news68',
      component: News68,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_68,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/69',
      alias: 'news69',
      component: News69,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_69,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/70',
      alias: 'news70',
      component: News70,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_70,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/71',
      alias: 'news71',
      component: News71,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_71,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/72',
      alias: 'news72',
      component: News72,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_72,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/73',
      alias: 'news73',
      component: News73,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_73,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/74',
      alias: 'news74',
      component: News74,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_74,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/75',
      alias: 'news75',
      component: News75,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_75,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/76',
      alias: 'news76',
      component: News76,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_76,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/77',
      alias: 'news77',
      component: News77,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_77,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/78',
      alias: 'news78',
      component: News78,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_78,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      path: '/open/news/79',
      alias: 'news79',
      component: News79,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_79,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      'path': '/open/news/80',
      alias: 'news80',
      component: News80,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_80,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      'path': '/open/news/81',
      alias: 'news81',
      component: News81,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_81,
        flexMode: Layout.LayoutMode.FLEX
      }
    },
    {
      'path': '/open/news/82',
      alias: 'news82',
      component: News82,
      meta: {
        exportKey: RouteKey.OPEN_NEWS_82,
        flexMode: Layout.LayoutMode.FLEX
      }
    }]
  },
  {
    path: '/open/academic',
    alias: 'academic',
    component: Academic,
    children: [{
      path: '/',
      alias: 'all',
      component: Academic,
      meta: {
        exportKey: RouteKey.OPEN_ACADEMIC_RESEARCH,
        flexMode: Layout.LayoutMode.FLEX,
        isAcademicActive: true
      }
    }]
  }]
};



// WEBPACK FOOTER //
// ./src/router/open.js